/* This is a generated file. Do not edit manually. */
import React from 'react';
import PropTypes from 'prop-types';
import iconSizes from '../../iconSizes';

/**
 * DuplicateIcon
 */
export default class DuplicateIcon extends React.Component {
  static propTypes = {
    /** The size of the icon */
    size: PropTypes.oneOf(['s', 'm', 'l', 'xl']),
    /** The color of the icon */
    color: PropTypes.string.isRequired
  };

  static defaultProps = {
    size: 'm',
    color: 'black'
  };

  render() {
    const { size: sizeProp, color } = this.props;
    const size = correctButtonSize(sizeProp);
    return (
      <svg
        focusable="false"
        xmlns="http://www.w3.org/2000/svg"
        viewBox={'0 0 32 32'}
        style={{ width: iconSizes[size], height: iconSizes[size] }}
      >
        <g style={{ fill: color }}>
          <svg viewBox="0 0 24 24"><path d="M18.813 2A3.188 3.188 0 0122 5.188v9.625A3.188 3.188 0 0118.812 18H18v.813A3.188 3.188 0 0114.812 22H5.188A3.188 3.188 0 012 18.812V9.188A3.188 3.188 0 015.188 6H6v-.813A3.188 3.188 0 019.188 2h9.624zm-4 6.125H5.187c-.586 0-1.062.476-1.062 1.063v9.624c0 .587.476 1.063 1.063 1.063h9.625c.586 0 1.062-.476 1.062-1.063V9.188c0-.586-.476-1.062-1.063-1.062zM10 9c.6 0 1 .4 1 1v3h3c.6 0 1 .4 1 1s-.4 1-1 1h-3v3c0 .6-.4 1-1 1s-1-.4-1-1v-3H6c-.6 0-1-.4-1-1s.4-1 1-1h3v-3c0-.6.4-1 1-1zm8.813-4.875H9.188c-.587 0-1.063.476-1.063 1.063L8.124 6h6.688A3.188 3.188 0 0118 9.188v6.687h.813c.586 0 1.062-.476 1.062-1.063V5.188c0-.587-.476-1.063-1.063-1.063z" fillRule="nonzero"/></svg>
        </g>
      </svg>
    );
  }
}

/* corrects deprecated api, can be removed in future release */
function correctButtonSize(size) {
  switch (size) {
    case 'medium':
      return 'm';
    case 'small':
      return 's';
    case 'large':
      return 'l';
    case 'xlarge':
      return 'xl';
    default:
      return size;
  }
}

